
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorNotAllowed as ObiCursorNotAllowedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-not-allowed.js';
 
 
 

 
 export const ObiCursorNotAllowed = createComponent({
   react: React,
   tagName: 'obi-cursor-not-allowed',
   elementClass: ObiCursorNotAllowedElement,
   events: {
     
   }
  });
 
 